/**
 * React Query hooks for call-related API operations
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../client';

export interface UpdateCallOutcomeRequest {
  callId: string;
  outcome: string;
  notes?: string;
  callback_date?: string; // ISO 8601 format
}

export interface UpdateCallOutcomeResponse {
  status: string;
  call_id: string;
}

/**
 * Update call outcome and trigger prospect cadencing
 */
export function useUpdateCallOutcome() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: UpdateCallOutcomeRequest): Promise<UpdateCallOutcomeResponse> => {
      const { callId, ...payload } = request;
      return await api.updateCallOutcome({
        call_id: callId,
        ...payload,
      });
    },
    onSuccess: () => {
      // Invalidate prospects query to refresh the list (prospect may have moved in/out of queue)
      queryClient.invalidateQueries({ queryKey: ['prospects'] });
      queryClient.invalidateQueries({ queryKey: ['calls'] });
    },
  });
}
